module.exports = __webpack_public_path__ + "media/images/konintodoke/diagnosis/kufumarry-logo-4576a1adf5eb6e1d1f41b9c2becb5bc1.svg";